import React, { useState, useEffect } from "react";
import Baseurl from "../../../Baseurl";
import { Table, Col, Card, Spinner, Modal } from "react-bootstrap";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
export default function ViewItems(props) {
  const { id, val } = props.match.params;
  const history = useHistory();
  const [restaurantDetails, setRestaurantDetails] = useState("");
  const [restaurant, setRestaurant] = useState("");
  const [reason, setReason] = useState("");
  const [spinnerAccept, setSpinnerAccept] = useState(false);
  const [show1, setShow1] = useState(false);
  const [rejectStatus, setRejectStatus] = useState(false);
  const [viewimage, setViewImage] = useState();
  const handleClose1 = () => {
    setShow1(false);
  };
  function getData() {
    axios
      .get(`${Baseurl.baseurl4}/go-food/get-item-by-id/${id}`)
      .then((res) => {
        console.log("Item details", res.data.item);
        let restoArr = [];
        if (res.data.status) {
          setRestaurant(res.data.item);
          restoArr.push(
            {
              name: "Item Name",
              val: res.data.item.RItemName,
            },
            {
              name: "Description",
              val: res.data.item.RItemDescription,
            },
            {
              name: "Item Price",
              val: `${res.data.item.RItemPrice} ₹`,
            },
            {
              name: "Tax Price",
              val: `${res.data.item.RItemPriceTax} ₹`,
            },
            {
              name: "Tax Percentage",
              val: res.data.item.RItemTax,
            },

            {
              name: "Type",
              val: res.data.item.RItemPureVeg ? "Veg" : "Non-Veg",
            },
            {
              name: "Preparation Time",
              val: res.data.item.RItemApproxPreparationTime,
            },
            {
              name: "Packing Charge",
              val: res.data.item.RItemPackingCharge,
            },
            {
              name: "Menu Name",
              val: res.data.item.RMenuName,
            },
            {
              name: "Restaurant Name",
              val: res.data.item.RName,
            },
            {
              name: "category",
              val: res.data.item.RItemCategory,
            }
          );
          setRestaurantDetails(restoArr);
        }
      });
  }
  useEffect(() => {
    getData();
  }, []);
  function acceptItems() {
    setSpinnerAccept(true);
    const params = {
        iId: id,
      // RegistrationToken:
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-super-admin/verify-restaurant-items-details`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Accepted", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          setSpinnerAccept(false);
          //history.push("/All-Items");
          history.goBack()
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  function viewImage(img) {
    setShow1(true);
    setViewImage(img);
  }
  function rejectItems() {
    const params = {
        iId: id,
        reason: reason,
      // RegistrationToken:
    };
    axios
      .put(
        `${Baseurl.baseurl4}/go-food-super-admin/reject-restaurant-items-details`,
        params
      )
      .then((res) => {
        if (res.data.status) {
          swal("Rejected", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          history.push("/Applied-Items");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        // if (err.toString() === "Error: Network Error") {
        //   history.push("/offline");
        // } else {
        //   history.push("/400");
        // }
      });
  }
  return (
    <div>
      <Col lg={12}>
        <Modal size="lg" show={show1} onHide={handleClose1}>
          <Modal.Body>
            {rejectStatus ? (
              <div className="row">
                <div className="col-sm-2 mt-2">
                  <label>Reason</label>
                </div>
                <div className="col-sm-8 ">
                  <textarea
                    type="text"
                    className="form-control"
                    id="val-username"
                    name="val-username"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Enter reason"
                  />
                </div>
              </div>
            ) : (
              <div>
                <img
                  alt=""
                  style={{
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                  className="playerProfilePic_home_tile"
                  src={viewimage}
                />
              </div>
            )}
          </Modal.Body>
          {rejectStatus && (
            <Modal.Footer>
              <button
                onClick={() => {
                  rejectItems();
                }}
                className="btn btn-danger"
              >
                Reject
              </button>
            </Modal.Footer>
          )}
        </Modal>
        <Card
          style={{
            color: "white",
            background:
              "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
          }}
        >
          <Card.Header>
            <div></div>
            <button
              className="btn btn-primary "
              onClick={() => {
                history.goBack();
              }}
            >
              Back
            </button>
          </Card.Header>
          <Card.Body>
         
            <Table className="text-white">
              {restaurantDetails &&
                restaurantDetails.map((val) => {
                  return (
                    <tr>
                      <td>{val.name}</td>
                      <td>{val.val}</td>
                    </tr>
                  );
                })}
            </Table>
            <div className="row mt-4">
                <div className="col-sm-3">
                  <label>Item Addon Category</label>
                </div>
                <div className="col-sm-9" >
                  <div className="row text-primary text-center">
                  <div className="col-sm-4">Name</div>
                            <div className="col-sm-4">Selection</div>
                           
                  </div>
                  <div className="row text-center">
  
                    {restaurant.RAddonCategory &&
                      restaurant.RAddonCategory.map((val) => {
                        return (
                          <>
                            <div className="col-sm-4">{val.RAddonCategoryName}</div>
                            <div className="col-sm-4">{val.RAddonCategorySelection}</div>
                          
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
          
            <div className="row mt-4">
                <div className="col-sm-3">
                  <label>Item Image</label>
                </div>
                <div classname="col-sm-4">
                  <div className="register_profile_image  ml-5  ">
                    {/* <input
                        required
                        id="profilePic"
                        type="file"
                        onChange={(e) => {
                          onChangePicture(e, "fssail");
                        }}
                      /> */}
                  </div>
                  {restaurant.RItemImage && (
                    <div
                      onClick={() => {
                        viewImage(restaurant.RItemImage);
                      }}
                      style={{
                        marginTop: "5px",
                        width: 180,
                        height: 100,
                        aspectRatio: 1 * 1.4,
                      }}
                      className="previewProfilePic"
                    >
                      <img
                        alt=""
                        className="playerProfilePic_home_tile"
                        style={{
                          resizeMode: "cover",
                          width: "100%",
                          height: "100%",
                        }}
                        src={restaurant.RItemImage}
                      />
                    </div>
                  )}
                </div>
              </div>
          </Card.Body>
          {!restaurant.RItemVerified&& (
            <Card.Footer>
              {spinnerAccept ? (
                <div className="ml-auto mr-2 float-right">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <button
                  className="btn btn-primary float-right"
                  onClick={() => {
                    acceptItems();
                  }}
                >
                  Accept
                </button>
              )}

              <button
                onClick={() => {
                  setRejectStatus(true);
                  setShow1(true);
                }}
                className="btn btn-danger text-center "
              >
                Reject
              </button>
            </Card.Footer>
          )}
        </Card>
      </Col>
    </div>
  );
}
